import React, { useEffect, useState } from "react";
import {
    Col,
    Container,
    Row,
    Form,
    Button,
    Spinner,
    Table,
    Modal,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import Pagination from "../../Common/Pagination";
import RejectButton from "../../Common/RejectButton";

const SurveyRejectedList = () => {
    const userState = useSelector((state) => state.loginData.userData);
    const financialYear = useSelector(state => state.activeData.activeMenu.activeTab)

    const navigate = useNavigate();

    // Variables for Zone-Gat Visitors Data ------------
    const [contractor, setContractor] = useState();
    const [loader, setLoader] = useState(false);

    // States for Pagination ----------
    const [pageNo, setPageNo] = useState(1);
    const [docPerPage, setDocPerPage] = useState(50);
    const [noOfPages, setNoOfPages] = useState(0);

    // function for pagination

    const handlePageChange = (pageNumber) => {
        setPageNo(pageNumber);
    };

    const handleDocsPerPage = (docsPageProp) => {
        setPageNo(1);
        setDocPerPage(docsPageProp);
    };


    //   useEffect API Calls
    useEffect(() => {
        getVisitReportList();
    }, [docPerPage, pageNo]);


    // get survey list data
    const getVisitReportList = async () => {
        setLoader(true);
        await fetch(
            process.env.REACT_APP_BASE_URL +
            "/billDistribution/getAllRejectedVisits",
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    documentsPerPage: docPerPage,
                    page: pageNo,
                    financialYear: financialYear === "old Dashboard" ? "2025-2026" : financialYear,
                    ...(userState?.usertype_keyname?.includes("zonalofficer")
                        ? {
                            zonekey: userState?.usertype_keyname?.includes("zonalofficer") ? userState?.zonekey : "",
                        }
                        : {}),
                    ...(userState?.usertype_keyname?.includes("gatlipik") && {
                        gatkey: userState?.gatkey
                    }),

                }),
            }
        )
            .then((res) => res.json())
            .then((response) => {
                if (response.status === 200) {
                    setContractor(response);
                    setNoOfPages(response.noOfPages);
                    setLoader(false);
                } else {
                    setContractor();
                    setNoOfPages(0);
                    setLoader(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoader(false);
            });
    };

    return (
        <div className="visitReport">
            <ToastContainer />
            <Container>
                <Row className="visitors mt-2">
                    <div className="container tbl-container p-0">
                        <div className="row tbl-fixed p-0" style={{ maxHeight: "65vh" }}>
                            <Table responsive="lg" hover>
                                <thead>
                                    <th>Sr No.</th>
                                    <th>Property Code</th>
                                    <th>Property Owner Name</th>
                                    <th>Property Owner Contact No</th>
                                    <th>Property Address</th>
                                    <th>Zone Name</th>
                                    <th>Gat Name</th>
                                    <th>Rejected Reason</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <center>
                                            <Spinner />
                                        </center>
                                    ) : contractor && contractor.data.length > 0 ? (
                                        contractor.data.map((row, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {pageNo !== 1 ? (
                                                            <> {index + 1 + docPerPage * (pageNo - 1)}</>
                                                        ) : (
                                                            <>{index + 1}</>
                                                        )}
                                                    </td>
                                                    <td>{row?.propertyCode ? row?.propertyCode : "-"}</td>
                                                    <td>{row?.propertyName ? row?.propertyName : "-"}</td>
                                                    <td>
                                                        {row?.propertyContactNo
                                                            ? row?.propertyContactNo
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        {row?.propertyAddress ? row?.propertyAddress : "-"}
                                                    </td>
                                                    <td>{row?.zonename ? row?.zonename : "-"}</td>
                                                    <td>{row?.gatname ? row?.gatname : "-"}</td>
                                                    <td>
                                                        {row?.rejectReason ? row?.rejectReason : "-"}
                                                    </td>
                                                    <td className="text-center">
                                                        <Icon.Eye
                                                            className="me-2"
                                                            style={{ cursor: "pointer" }}
                                                            size={25}
                                                            onClick={() =>
                                                                navigate("/dashboard/survey-rejected-view-list", {
                                                                    state: {
                                                                        report: row,
                                                                        comesFrom: "Survey Verification History",
                                                                    },
                                                                })
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>No data found</tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <Row>
                            <Col md={4} className="d-flex align-items-center mt-3 mt-md-0">
                                <h6 className="text-start mb-0">
                                    <Icon.People className="me-2" />
                                    Total - <strong>{contractor?.count}</strong>
                                </h6>
                            </Col>
                            <Col md={8} className="d-flex justify-content-end">
                                <Pagination
                                    currentPage={pageNo}
                                    totalPages={noOfPages}
                                    onPageChange={handlePageChange}
                                    onDocsPerPage={handleDocsPerPage}
                                    docsPerPage={docPerPage}
                                />
                            </Col>
                        </Row>
                    </div>
                </Row>
            </Container>
        </div >
    );
};

export default SurveyRejectedList;
